import swaggerClient from "../remote-client";

const strict = true;

const state = {
  documents: [],
  documentIds: new Map(),
  document: {},
  documentId: null
};

const getters = {
  documents: state => state.documents,
  documentIds: state => state.documentIds,
  document: state => state.document,
  documentId: state => state.documentId
};

const mutations = {
  reset(state) {
    state.documents = [];
    state.documentIds = new Map();
    state.document = {};
    state.documentId = null;
  },
  resetDocument(state) {
    state.document = {};
    state.documentId = null;
  },
  loadingDocument(state) {
    state.document = {};
    state.documentId = null;
  },
  updateDocument(state, { document }) {
    state.document = document;
  },
  uploadingDocument(state) {
    state.documentId = null;
  },
  documentUploaded(state, response) {
    state.documentId = response.documentId;
  },
  resetDocuments(state) {
    state.documents = [];
    state.documentIds = new Map();
  },
  updateDocuments(state, { document }) {
    let counter = 0;
    state.documents.forEach(doc => {
      if (doc.name == document.name) counter++;
    });
    if (counter != 0) {
      let name = document.name;
      document.name =
        name.substring(0, name.indexOf(".")) +
        " (" +
        counter +
        ")" +
        name.substring(name.indexOf("."));
    }
    state.documents.push(document);
  },
  deleteFile(state, document) {
    let index = state.documents.findIndex(doc => {
      return document.name == doc.name;
    });
    if (index != -1) {
      state.documents.splice(index, 1);
    }
  },
  uploadingDocuments(state) {
    state.documentIds = new Map();
  },
  documentsUploaded(state, { type, documentId }) {
    state.documentIds.set(type, documentId);
  }
};

const actions = {
  reset({ commit }) {
    commit("reset");
  },
  delete({ commit }, document) {
    commit("deleteFile", document);
  },

  /**
   * Used to load only one document before to call the uploadDocument action
   */
  loadDocument(
    { commit },
    { file, acceptedFormats, maxFileSize, documentType }
  ) {
    commit("loadingDocument");
    commit("loading/openLoadingDialog", null, {
      root: true
    });

    if (file) {
      if (file.size > maxFileSize) {
        commit("loading/closeLoadingDialog", null, {
          root: true
        });
        commit(
          "error/setError",
          {
            type: "wrong-file-dimension",
            body: null,
            headers: null
          },
          {
            root: true
          }
        );
      } else {
        if (acceptedFormats.includes(file.type)) {
          let reader = new FileReader();
          reader.onload = function () {
            const document = {
              type: documentType,
              name: file.name,
              contentType: file.type,
              content: btoa(reader.result)
            };

            commit("updateDocument", { document });
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
          };
          reader.readAsBinaryString(file);
          reader.onerror = function () {
            reader.abort();
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: "generic-file-upload",
                body: null,
                headers: null
              },
              {
                root: true
              }
            );
          };
        } else {
          commit("loading/closeLoadingDialog", null, {
            root: true
          });
          commit(
            "error/setError",
            {
              type: "wrong-file-format",
              body: null,
              headers: null
            },
            {
              root: true
            }
          );
        }
      }
    } else {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
      commit(
        "error/setError",
        {
          type: "generic-file-upload",
          body: null,
          headers: null
        },
        {
          root: true
        }
      );
    }
  },
  /**
   * Upload a single document (that was loaded using loadDocument action)
   */
  uploadDocument({ state, commit }) {
    commit("uploadingDocument");
    commit("loading/openLoadingDialog", null, {
      root: true
    });
    return new Promise(resolve => {
      swaggerClient.nestCommonSwaggerClient
        .then(
          function (client) {
            return client.apis.Documents.postDocument(
              {},
              swaggerClient.buildRequest(state.document),
              {}
            );
          },
          function () {
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: "unable-to-call-api",
                body: null,
                headers: null
              },
              {
                root: true
              }
            );
          }
        )
        .then(
          function (result) {
            commit("documentUploaded", result.body);
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            resolve();
          },
          function (reason) {
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: reason.message == "" ? null : reason.message,
                body: reason.message == "" ? reason.response.body : null,
                headers: reason.message == "" ? reason.response.headers : null
              },
              {
                root: true
              }
            );
          }
        );
    });
  },
  /**
   * Used to load multiple document before to call the uploadDocuments action
   */
  loadDocuments(
    { commit },
    { file, acceptedFormats, maxFileSize, documentType }
  ) {
    // eslint-disable-next-line no-console
    console.log(file);
    commit("loading/openLoadingDialog", null, {
      root: true
    });
    if (file) {
      if (file.size > maxFileSize) {
        commit("loading/closeLoadingDialog", null, {
          root: true
        });
        commit(
          "error/setError",
          {
            type: "wrong-file-dimension",
            body: null,
            headers: null
          },
          {
            root: true
          }
        );
      } else {
        if (acceptedFormats.includes(file.type)) {
          let reader = new FileReader();
          reader.onload = function () {
            const document = {
              type: documentType,
              name: file.name,
              contentType: file.type,
              content: btoa(reader.result),
              lastModified: file.lastModified
            };
            commit("updateDocuments", { document });
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
          };
          reader.readAsBinaryString(file);
          reader.onerror = function () {
            reader.abort();
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: "generic-file-upload",
                body: null,
                headers: null
              },
              {
                root: true
              }
            );
          };
        } else {
          commit("loading/closeLoadingDialog", null, {
            root: true
          });
          commit(
            "error/setError",
            {
              type: "wrong-file-format",
              body: null,
              headers: null
            },
            {
              root: true
            }
          );
        }
      }
    } else {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
      commit(
        "error/setError",
        {
          type: "generic-file-upload",
          body: null,
          headers: null
        },
        {
          root: true
        }
      );
    }
  },
  /**
   * Upload a list of documents (that were loaded using loadDocuments action)
   */
  uploadDocuments({ commit }, document) {
    commit("uploadingDocuments");
    return new Promise(resolve => {
      swaggerClient.nestCommonSwaggerClient
        .then(
          function (client) {
            return client.apis.Documents.postDocument(
              {},
              swaggerClient.buildRequest(document),
              {}
            );
          },
          function () {
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: "unable-to-call-api",
                body: null,
                headers: null
              },
              {
                root: true
              }
            );
          }
        )
        .then(
          function (result) {
            let type = document.type;
            let documentId = result.body.documentId;
            commit("documentsUploaded", { type, documentId });
            resolve();
          },
          function (reason) {
            commit("loading/closeLoadingDialog", null, {
              root: true
            });
            commit(
              "error/setError",
              {
                type: reason.message == "" ? null : reason.message,
                body: reason.message == "" ? reason.response.body : null,
                headers: reason.message == "" ? reason.response.headers : null
              },
              {
                root: true
              }
            );
          }
        );
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
